import React, { Fragment } from 'react';
import DateFnsUtils from '@date-io/date-fns';

import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import { Box, Typography, Button, Popover, createMuiTheme } from '@material-ui/core'
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../../layout/themes';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles'
import { useTranslate } from 'react-admin';
import { TimePicker } from '@material-ui/pickers'
import { lightBlue, grey } from '@material-ui/core/colors';

import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

const useStyles = makeStyles((theme) => ({
    isOpenNotValue: {
        position: 'relative',
        color: '#237fc2',
        marginTop: 5,
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
    },
    isOpen: {
        position: 'relative',
        marginTop: 5,
        color: '#88898c',
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
    },
    notOpen: {
        color: '#88898c',
        bottom: 0,
        marginTop: 16,
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
    },
    TitleDateTime: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    Time: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    Date: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: ' 0.13px',
        color: '#4f5064',
    },
  
    btnOk: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: ' #237fc2',
    },
    TextOk: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: ' #237fc2',
    }


}));


const materialTheme = createMuiTheme({
    overrides: {
        MuiPickersToolbar: {
            toolbar: {
                height: '70px',
                backgroundColor: '#237fc2'
            },
        },
        MuiPickersToolbarText: {
            toolbarTxt: {
                fontFamily: 'UniviaPro',
                fontSize: '11px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.25,
                letterSpacing: '0.11px',
                color: 'rgba(255, 255, 255, 0.7)',
            },
            toolbarBtnSelected: {
                fontFamily: 'UniviaPro',
                fontSize: '18px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 2.83,
                letterSpacing: '0.25px',
                color: '#ffffff',
            }
        },
        MuiPickersDay: {
            daySelected: {
                backgroundColor: '#237fc2',
                color: '#ffffff'
            },
        },
        MuiTypography: {
            alignCenter: {
                fontFamily: 'UniviaPro-Medium',
                fontSize: '14px',
                fontWeight: 500,
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.2,
                letterSpacing: 'normal',
                color: '#4f5064',
            },
            colorInherit: {
                fontFamily: 'UniviaPro',
                fontSize: '11px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.25,
                letterSpacing: '0.11px',
                // color: '#4f5064',
            }
        },
        MuiPickersCalendarHeader: {
            dayLabel: {
                fontFamily: 'UniviaPro',
                fontSize: '9px ',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: '15px',
                letterSpacing: '0.11px',
                color: 'rgba(0, 0, 0, 0.6)',
            }
        },
        MuiPickersClockNumber: {
            clockNumber: {
                fontFamily: 'UniviaPro',
                fontSize: '11px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.25,
                letterSpacing: '0.11px',
            }
        },
        MuiButton: {
            label: {
                fontFamily: 'UniviaPro',
                fontSize: '10px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.25,
                letterSpacing: '0.4px',

            }
        }
        , MuiPickersYear: {
            yearSelected: {
                fontFamily: 'UniviaPro',
                fontSize: '18px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 2.83,
                letterSpacing: '0.25px',
            },
            root: {
                fontFamily: 'UniviaPro',
                fontSize: '14px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 2.83,
                letterSpacing: '0.25px',

            }
        }
    },
});




export default function TimePickerCalendar({ time, handleTimeChange, openTimePicker, handleDateChange, date, setOpenTimePicker, hours }) {
    const classes = useStyles();
    const translate = useTranslate();
    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );
    return (
        <ThemeProvider theme={materialTheme}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <div>
                    <Box>
                        {
                            hours ?
                                <TimePicker
                                    TextFieldComponent={() => <Box hidden={true}></Box>}
                                    open={openTimePicker}
                                    onClose={() => setOpenTimePicker(false)}
                                    ampm={false}
                                    openTo="hours"
                                    views={["hours", "minutes"]}
                                    format="HH:mm"
                                    value={time}
                                    onChange={handleTimeChange}
                                    InputProps={{
                                        className: classes.Time,
                                    }}
                                /> : <TimePicker
                                    TextFieldComponent={() => <Box hidden={true}></Box>}
                                    open={openTimePicker}
                                    onClose={() => setOpenTimePicker(false)}
                                    ampm={false}
                                    openTo="hours"
                                    views={["hours", "minutes", "seconds"]}
                                    format="HH:mm:ss"
                                    value={date}
                                    onChange={handleDateChange}
                                    InputProps={{
                                        className: classes.Time,
                                    }}
                                />}

                    </Box>
                </div>
            </MuiPickersUtilsProvider>
        </ThemeProvider>
    );
}